export default __webpack_public_path__ + "static/media/doctor_man.e0b26f74.svg";